export const OrderPaymentConstants = {
    INVOICE_NET_30_CREDIT_APPLICATION_TOOLTIP:
        'Invoice Net 30 will be available after credit application acceptance by EWA.',
} as const;
